import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import Button from '@vtex/styleguide/lib/Button'

import Icon from '@/checkout-instore-legacy/components/Commons/Icons'
import { hasAnyECommercePaymentOnPaymentList } from '@/checkout-instore-legacy/order/utils'

const AddPaymentButton = ({ value, payments, giftCards, onClick }) => {
  const totalUsedValueInGiftCards = giftCards.reduce(
    (sum, card) => sum + card.value,
    0
  )
  const hasNoSelectedPayments =
    (!payments || payments.length === 0) && totalUsedValueInGiftCards === 0

  const hasSelectedEcommercePayments = hasAnyECommercePaymentOnPaymentList(
    payments
  )

  return !hasNoSelectedPayments &&
    totalUsedValueInGiftCards < value &&
    !hasSelectedEcommercePayments ? (
    <div
      className="flex justify-center items-center tc mv5 mv7-l"
      data-testid="add-another-payment"
    >
      <div className="c-action-primary hover-c-action-primary f0 relative left-1-5 z-1">
        <Icon type="plus" />
      </div>
      <Button
        id="addPayment"
        type="button"
        variation="tertiary"
        className="tc"
        onClick={onClick}
      >
        <FormattedMessage id="addAnotherPayment" />
      </Button>
    </div>
  ) : null
}

AddPaymentButton.propTypes = {
  payments: PropTypes.array,
  value: PropTypes.number,
  giftCards: PropTypes.array,
  onClick: PropTypes.func,
}

export default AddPaymentButton
